export const roles = {
  ADMIN: "ADMIN",
  USER: "USER",
  INSTRUCTOR: "INSTRUCTOR",
  CREATOR: "CREATOR",
};
